import { useParams, Link } from 'react-router-dom';
import { useEffect } from 'react';
import Breadcrumb from '@/components/feature/Breadcrumb';
import { articles, categories } from '@/mocks/articles';
import Newsletter from '@/pages/home/components/Newsletter';

const detailImages: Record<string, string> = {
  'article-role-1': 'https://readdy.ai/api/search-image?query=Elegant%20woman%20gazing%20thoughtfully%20at%20her%20wedding%20ring%20by%20a%20sunlit%20window%2C%20cream%20blouse%2C%20soft%20natural%20light%2C%20warm%20minimalist%20interior%2C%20feminine%20portrait%2C%20gentle%20expression%2C%20pastel%20cream%20and%20blush%20tones%2C%20artistic%20photography&width=1200&height=600&seq=detail-role-1&orientation=landscape',
  'article-role-2': 'https://readdy.ai/api/search-image?query=Mother%20in%20law%20and%20daughter%20in%20law%20sharing%20tea%20in%20a%20bright%20cozy%20living%20room%2C%20warm%20atmosphere%2C%20gentle%20smiles%2C%20cream%20interior%2C%20soft%20sunlight%2C%20harmonious%20moment&width=1200&height=600&seq=detail-role-2&orientation=landscape',
  'article-role-3': 'https://readdy.ai/api/search-image?query=Professional%20woman%20working%20on%20laptop%20at%20a%20modern%20home%20desk%2C%20warm%20natural%20light%20from%20window%2C%20balanced%20lifestyle%2C%20cream%20and%20wood%20tones%2C%20calm%20productive%20atmosphere&width=1200&height=600&seq=detail-role-3&orientation=landscape',
  'article-couple-1': 'https://readdy.ai/api/search-image?query=Couple%20having%20intimate%20conversation%20on%20a%20balcony%20at%20sunset%2C%20warm%20golden%20light%2C%20holding%20hands%2C%20cream%20and%20warm%20coral%20tones%2C%20romantic%20atmosphere%2C%20emotional%20connection&width=1200&height=600&seq=detail-couple-1&orientation=landscape',
  'article-couple-2': 'https://readdy.ai/api/search-image?query=Two%20people%20sitting%20close%20on%20a%20park%20bench%20in%20autumn%2C%20one%20giving%20a%20thoughtful%20gift%2C%20warm%20golden%20leaves%2C%20cream%20and%20amber%20tones%2C%20emotional%20connection&width=1200&height=600&seq=detail-couple-2&orientation=landscape',
  'article-couple-3': 'https://readdy.ai/api/search-image?query=Couple%20reconciling%20after%20an%20argument%2C%20gentle%20embrace%20in%20a%20cozy%20room%2C%20soft%20evening%20lighting%2C%20cream%20and%20warm%20tones%2C%20emotional%20healing%20moment&width=1200&height=600&seq=detail-couple-3&orientation=landscape',
  'article-marriage-1': 'https://readdy.ai/api/search-image?query=Two%20intertwined%20hands%20with%20wedding%20bands%20resting%20on%20soft%20silk%20fabric%2C%20delicate%20flowers%2C%20warm%20golden%20hour%20light%2C%20cream%20and%20rose%20gold%20tones%2C%20elegant%20romantic%20still%20life&width=1200&height=600&seq=detail-marr-1&orientation=landscape',
  'article-marriage-2': 'https://readdy.ai/api/search-image?query=Couple%20reviewing%20financial%20documents%20together%20at%20a%20cozy%20wooden%20table%2C%20warm%20table%20lamp%20light%2C%20collaborative%20mood%2C%20cream%20and%20warm%20brown%20tones&width=1200&height=600&seq=detail-marr-2&orientation=landscape',
  'article-marriage-3': 'https://readdy.ai/api/search-image?query=Couple%20dancing%20slowly%20in%20their%20living%20room%2C%20spontaneous%20romantic%20moment%2C%20warm%20candlelight%2C%20cream%20interior%2C%20soft%20shadows%2C%20intimate%20atmosphere&width=1200&height=600&seq=detail-marr-3&orientation=landscape',
  'article-newlywed-1': 'https://readdy.ai/api/search-image?query=Newlywed%20couple%20unpacking%20boxes%20in%20their%20first%20bright%20apartment%2C%20excited%20and%20playful%2C%20natural%20light%20streaming%20in%2C%20cream%20walls%2C%20fresh%20start&width=1200&height=600&seq=detail-new-1&orientation=landscape',
  'article-newlywed-2': 'https://readdy.ai/api/search-image?query=Couple%20enjoying%20morning%20coffee%20together%20in%20a%20bright%20modern%20kitchen%2C%20casual%20and%20happy%2C%20warm%20morning%20light%2C%20lifestyle%20photography&width=1200&height=600&seq=detail-new-2&orientation=landscape',
  'article-newlywed-3': 'https://readdy.ai/api/search-image?query=Woman%20practicing%20yoga%20in%20a%20sunlit%20room%20with%20plants%2C%20peaceful%20expression%2C%20cream%20and%20sage%20green%20tones%2C%20self%20care%20moment%2C%20serene%20atmosphere&width=1200&height=600&seq=detail-new-3&orientation=landscape',
  'article-family-1': 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20warm%20throw%20blankets%20and%20candles%2C%20soft%20evening%20light%2C%20cream%20and%20taupe%20interior%2C%20inviting%20home%20atmosphere%2C%20relaxing%20vibe&width=1200&height=600&seq=detail-fam-1&orientation=landscape',
  'article-family-2': 'https://readdy.ai/api/search-image?query=Couple%20cooking%20dinner%20together%20in%20a%20warm%20kitchen%2C%20laughing%2C%20fresh%20vegetables%20on%20counter%2C%20cozy%20evening%20atmosphere%2C%20cream%20cabinets&width=1200&height=600&seq=detail-fam-2&orientation=landscape',
  'article-self-1': 'https://readdy.ai/api/search-image?query=Confident%20woman%20journaling%20in%20a%20cozy%20cafe%20corner%2C%20warm%20ambient%20light%2C%20notebook%20and%20coffee%2C%20cream%20and%20warm%20brown%20tones%2C%20serene%20expression&width=1200&height=600&seq=detail-self-1&orientation=landscape',
  'article-self-2': 'https://readdy.ai/api/search-image?query=Woman%20painting%20on%20canvas%20in%20a%20bright%20art%20studio%2C%20passionate%20expression%2C%20creative%20atmosphere%2C%20warm%20natural%20light%2C%20colorful%20palette&width=1200&height=600&seq=detail-self-2&orientation=landscape',
};

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [slug]);

  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <main className="pt-16 bg-background-50 min-h-screen flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-heading font-semibold text-foreground-900 mb-3">文章未找到</h1>
          <p className="text-foreground-600 mb-6">抱歉，你查找的文章不存在或已被移除。</p>
          <Link
            to="/"
            className="px-6 py-3 bg-primary-500 text-white rounded-full text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            返回首页
          </Link>
        </div>
      </main>
    );
  }

  const relatedArticles = articles
    .filter((a) => a.id !== article.id && (a.categorySlug === article.categorySlug || a.tags.some((t) => article.tags.includes(t))))
    .slice(0, 3);

  const categoryInfo = categories.find((c) => c.slug === article.categorySlug);

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'Article',
            headline: article.title,
            description: article.excerpt,
            author: { '@type': 'Person', name: article.author },
            datePublished: article.date,
            image: detailImages[article.imageSeq],
            publisher: {
              '@type': 'Organization',
              name: '第一次的人妻',
            },
          }),
        }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'https://diyiciderenqi.com/' },
              { '@type': 'ListItem', position: 2, name: article.category, item: `https://diyiciderenqi.com/category/${article.categorySlug}` },
              { '@type': 'ListItem', position: 3, name: article.title },
            ],
          }),
        }}
      />

      <main className="pt-16 bg-background-50 min-h-screen">
        <article>
          <div className="max-w-4xl mx-auto px-4 md:px-8">
            <Breadcrumb
              items={[
                { label: '首页', to: '/' },
                { label: article.category, to: `/category/${article.categorySlug}` },
                { label: article.title },
              ]}
            />

            <header className="mb-8 md:mb-10">
              <div className="flex flex-wrap items-center gap-2 mb-4">
                <Link
                  to={`/category/${article.categorySlug}`}
                  className="px-3 py-1 text-xs rounded-full bg-primary-100 text-primary-700 font-medium hover:bg-primary-200 transition-colors"
                >
                  {article.category}
                </Link>
                {article.tags.map((tag) => (
                  <span key={tag} className="px-3 py-1 text-xs rounded-full bg-secondary-100 text-secondary-700">
                    {tag}
                  </span>
                ))}
              </div>

              <h1 className="text-2xl md:text-4xl font-heading font-semibold text-foreground-900 leading-tight mb-4 md:mb-5">
                {article.title}
              </h1>

              <div className="flex flex-wrap items-center gap-4 text-sm text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-user-line"></i> {article.author}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-calendar-line"></i> {article.date}
                </span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line"></i> 阅读时间 {article.readTime}
                </span>
              </div>
            </header>

            <div className="relative rounded-2xl overflow-hidden aspect-[2/1] mb-8 md:mb-10">
              <img
                src={detailImages[article.imageSeq]}
                alt={article.title}
                className="w-full h-full object-cover"
              />
            </div>

            <div
              className="prose prose-lg max-w-none mb-12 md:mb-16
                prose-headings:font-heading prose-headings:text-foreground-900 prose-headings:font-semibold
                prose-h2:text-xl md:prose-h2:text-2xl prose-h2:mt-10 prose-h2:mb-5
                prose-p:text-foreground-700 prose-p:leading-relaxed prose-p:text-base md:prose-p:text-lg prose-p:mb-5
                prose-strong:text-foreground-900
                [&_p]:text-base [&_p]:md:text-lg
              "
              dangerouslySetInnerHTML={{ __html: article.content }}
            />
          </div>
        </article>

        {relatedArticles.length > 0 && (
          <section className="py-14 md:py-20 bg-background-100" data-product-shop>
            <div className="max-w-7xl mx-auto px-4 md:px-8">
              <h2 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mb-8 text-center">
                相关推荐
              </h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
                {relatedArticles.map((related) => (
                  <article key={related.id} className="group bg-white rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer">
                    <Link to={`/article/${related.slug}`} className="block">
                      <div className="relative aspect-[16/9] overflow-hidden">
                        <img
                          src={detailImages[related.imageSeq]}
                          alt={related.title}
                          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                          loading="lazy"
                        />
                        <div className="absolute top-3 left-3">
                          <span className="px-2.5 py-1 text-xs rounded-full bg-white/85 backdrop-blur-sm text-foreground-700 font-medium">
                            {related.category}
                          </span>
                        </div>
                      </div>
                      <div className="p-4 md:p-5">
                        <h3 className="text-base font-heading font-medium text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors line-clamp-2">
                          {related.title}
                        </h3>
                        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-3">
                          {related.excerpt}
                        </p>
                        <div className="flex items-center gap-3 text-xs text-foreground-500">
                          <span>{related.date}</span>
                          <span>{related.readTime}</span>
                        </div>
                      </div>
                    </Link>
                  </article>
                ))}
              </div>
            </div>
          </section>
        )}

        <Newsletter />
      </main>
    </>
  );
}